import { render, staticRenderFns } from "./EWUserDetailList.vue?vue&type=template&id=38f24a41&"
import script from "./EWUserDetailList.vue?vue&type=script&lang=js&"
export * from "./EWUserDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports